import React from "react";
import styled from "styled-components";
import Navbar from "../SubComponents/Navbar";
import { Link } from "react-router-dom";

import { useQuery } from "@apollo/react-hooks";
import { QUERY_EVENTS } from "../utils/queries";

import party1 from "../assets/party1.jpg";
import event2 from "../assets/event2.jpg";
import img2 from "../assets/img2.png";

import concert2 from "../assets/events/concert2.webp";
import event4 from "../assets/events/event4.avif";
import event5 from "../assets/events/event5.webp";
import event6 from "../assets/events/event6.webp";

const Section = styled.div`
  width: 100vw;
  min-height: 100vh;

  display: flex;
  flex-direction: column;
  background-color: rgba(32, 32, 32, 0.3);
`;

const Heading = styled.div`
  width: 85%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  padding: 0.5rem 2rem;
  font-size: 2rem;
  color: whitesmoke;

  h2 {
    font-size: 2rem;
  }
`;

const NewsBox = styled.div`
  width: 80%;
  height: auto;
  margin: 1rem auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
`;

const MainContainer = styled.div`
  width: 35vw;
  height: 40vh;
  margin: 1rem;
  position: relative;
  transition: all 0.2s ease;

  &:hover {
    transform: scale(1.1);
  }
`;

const ImagContainer = styled.div`
  width: 100%;
  height: 100%;
  object-fit: fill;

  img {
    border-radius: 25px;
    width: 35vw;
    height: 40vh;
  }
`;

const Event = styled.div`
  width: 90%;
  position: absolute;
  bottom: 1rem;
  left: 0.5rem;
  z-index: 5;
  color: white;
  padding: 4px 2px 4px 4px;

  h1 {
    font-size: 2rem;
    cursor: pointer;
  }

  h2 {
    color: orange;
    font-size: 1rem;
  }

  h3 {
    font-size: 0.9rem;
  }
`;

const Details = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  div {
    display: flex;
    align-items: center;
  }
`;

const NewContainer = ({ img, type, link, event, location, date }) => {
  return (
    <MainContainer>
      <ImagContainer>
        <img src={img} alt="news" />
      </ImagContainer>
      <Event>
        <h2>{type}</h2>
        <Link to={{ pathname: `${link}` }} target="_blank">
          <h1>{event}</h1>
        </Link>
        <Details>
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path d="M12 0c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z" />
            </svg>
            <h3>{location}</h3>
          </div>
          <h3>{date}</h3>
        </Details>
      </Event>
    </MainContainer>
  );
};

const Events = () => {
  const { loading, data: eventData } = useQuery(QUERY_EVENTS);
  console.log(eventData);
  return (
    <Section>
      <Navbar />
      <Heading>
        <h1>Beach Events..</h1>
        <h2>Look what's happening around....</h2>
      </Heading>
      <NewsBox>
        <NewContainer
          img={party1}
          type="Experience"
          link=""
          event="Splash Electronic dance party"
          location="Virginia beach"
          date="12/06/2022"
        />
        <NewContainer
          img={concert2}
          type="Concert"
          link="//beacheventsvb.com/festivals/"
          event="Splash Electronic dance party"
          location="24th Street Park: SPLASH EDM Dance Party"
          date="14/06/2022"
        />
        <NewContainer
          img={event2}
          type="Concert"
          link="//beacheventsvb.com/events/oceanfront-concert-series-carbon-leaf/"
          event="OceanFront Concert Series"
          location="Virginia beach"
          date="15/06/2022"
        />
        <NewContainer
          img={event5}
          type="Creativity"
          link="//beacheventsvb.com/events/chalk-the-walk/"
          location="On the Boardwalk from 16th-18th Streets"
          event="Chalk the Walk"
          date="16/06/2022"
        />
        <NewContainer
          img={event4}
          type="Tournament"
          link="//www.eventbrite.com/e/balmy-beach-old-boys-beach-volleyball-tournament-2022-tickets-348403112087?aff=ebdssbdestsearch&keep_tld=1"
          event="Beach VolleyBall Tournament'22"
          location="Toronto"
          date="18/06/2022"
        />
        <NewContainer
          img={event6}
          type="Experience"
          link="//beacheventsvb.com/events/beach-blanket-movie-series-sonic-the-hedgehog/"
          event="Beach blanket CINEMA"
          location="On Beach 29th Street"
          date="30/06/2022"
        />
      </NewsBox>
    </Section>
  );
};

// <Section>
//       <BlackWrapper />
//       <Navbar />
//       <ImageContainer>
//         <img src={img2} alt="beach" />
//       </ImageContainer>
//     </Section>

// {
//   eventData.map( d =>
//     <NewContainer key={d.id} data={d} />
//   )
// }

// {loading ? (
//   <h3>Loading...</h3>
// ) : (
//   eventData.events.map((event) => (
//     <NewContainer
//       key={event._id}
//       img={party1}
//       type="Experience"
//       link="//beacheventsvb.com/events/oceanfront-concert-series-carbon-leaf/"
//       event={event.name}
//       location={event.host.city}
//       date={event.dates[0].day}
//     />
//   ))
// )}

export default Events;
